<template>
    <div>
        <top-header :pageTitle=pageTitle :pageSubtitle=pageSubtitle></top-header>
        <basic-article v-bind="article"></basic-article>
    </div>
</template>

<script>
import BasicArticle from '../components/BasicArticle.vue'
import TopHeader from '../components/TopHeader.vue';
import { reqgetCompanyLsjz } from '../api';

export default {
    components: { BasicArticle, TopHeader },
    name: 'Lsjz',
    data() {
        return {
            pageTitle: "联盛浆纸（漳州）有限公司",
            pageSubtitle: "LIANSHENG PULP&PAPER (ZHANGZHOU) CO., LTD.",
            article: {}
        };
    },
    async mounted() {
        try {
            let jsonData = await reqgetCompanyLsjz(); // 调用异步函数获取数据
            this.article = jsonData.data
        } catch (error) {
            console.error('Failed to fetch category list:', error);
        }
    }
}  
</script>
<style scoped></style>


// WEBPACK FOOTER //
// src/view/Lsjz.vue